import * as ActionTypes from '../constants/ActionTypes';
import { httpClient } from '../../lib/utils';
import Url from '../../lib/config';

function uploadImage(image, hotelId, target) {
    return dispatch => {
        dispatch({
            type: ActionTypes.IMAGES_UPLOAD_REQUEST,
            image,
            target
        });
        let uploadData = new FormData();
        uploadData.append('thefile', new Blob([image]), { type: image.type });
        return httpClient
            .post(Url.upload + '?level=hotel/' + hotelId + '/' + target, uploadData)
            .then(res => {
                dispatch({ type: ActionTypes.IMAGES_UPLOAD_SUCCESS, message: res.data, hotelId: hotelId, target });
                dispatch({ type: ActionTypes.IMAGES_ADD_TO_LIBRARY, image: res.data, hotelId: hotelId, target });
            })
            .catch(err => {
                dispatch({ type: ActionTypes.IMAGES_UPLOAD_FAILURE, error: err.message, hotelId: hotelId, target });
            });
    };
}

function uploadBackgroundImage(image, hotelId) {
    return uploadImage(image, hotelId, 'backgroundImage');
}

function uploadHotelLogo(image, hotelId) {
    return uploadImage(image, hotelId, 'hotelLogo');
}

export { uploadHotelLogo, uploadBackgroundImage };



// WEBPACK FOOTER //
// ./src/actions/images.js